export default __webpack_public_path__ + "static/media/ET_2020-21.e1140e6c.webm";